import type { EventRow } from "../types/event";

export function normalizeStatus(status: any): EventRow["status"] {
  const s = String(status || "").toLowerCase().trim();
  
  // Mapeia variações em português e inglês
  if (s === "cancelado" || s === "cancelled") return "cancelled";
  if (s === "adiado" || s === "postponed") return "postponed";
  if (s === "agendado" || s === "scheduled" || s === "") return "scheduled";
  
  return "scheduled"; // fallback
}

export function normalizeRow(obj: Record<string, any>, idx: number): EventRow {
  // helper para normalizar strings
  const S = (v: any) => (v === null || v === undefined ? "" : String(v).trim());

  return {
    id: S(obj.id) || String(idx + 1),               // <-- força string
    title: S(obj.title) || S(obj.titulo) || "(Sem título)",
    description: S(obj.description) || S(obj.descricao),
    start_iso: S(obj.start_iso) || S(obj.inicio_iso) || S(obj.start) || S(obj.inicio),
    end_iso: S(obj.end_iso) || S(obj.fim_iso) || S(obj.end) || S(obj.fim),
    timezone: S(obj.timezone) || undefined,
    location_type: (S(obj.location_type) || S(obj.tipo_local) || "online") as EventRow["location_type"],
    location_name: S(obj.location_name) || S(obj.local),
    address: S(obj.address) || S(obj.endereco),
    city: S(obj.city) || S(obj.cidade),
    state: S(obj.state) || S(obj.estado),
    country: S(obj.country) || S(obj.pais),
    join_url: S(obj.join_url) || S(obj.link) || S(obj.url),
    rsvp_url: S(obj.rsvp_url) || S(obj.inscricao),
    recording_url: S(obj.recording_url) || S(obj.gravacao),
    speakers: S(obj.speakers) || S(obj.palestrantes),
    tags: S(obj.tags),
    cover_image: S(obj.cover_image) || S(obj.capa),
    status: normalizeStatus(obj.status),
    rrule: S(obj.rrule) || S(obj.RRULE) || undefined,
    exdates: S(obj.exdates) || S(obj.EXDATES) || undefined,
    series: S(obj.series),
    episode: S(obj.episode),
    destaque: S(obj.destaque) || undefined,
  };
}